import React from 'react';

export function PricePanel({ totalPrice, period, regularPrice, discountPercent }) {
    const hasDiscount = discountPercent > 0;
    const formatPrice = (price) => `${price}₽`;

    return (
        <div className="v1_125">
            {hasDiscount && (
            <span className="discount-badge">-{discountPercent}%</span>
        )}
            <div className="v1_126">

                <div className="price-info">
                    {hasDiscount && (
                        <span className="v1_127 regular-price">
                            {formatPrice(regularPrice)}
                        </span>
                    )}
                    <span className={`v1_127 ${hasDiscount ? 'discounted' : ''}`}>
                        {formatPrice(totalPrice)}
                    </span>
                </div>
                <span className="v1_128">VLESS · {period} мес</span>
            </div>

        </div>
    );
}